import { Box, SxProps, Typography } from "@mui/material";
import Image from "./Image";
import { Icons } from "../../models/assets-files";
import { ImageService } from "../../services/image.service";

interface UserAvatarProps {
  imgSrc?: string;
  subtitle?: string;
  username?: string;
  sx?: SxProps;
}

const UserAvatar = ({ imgSrc, subtitle, username, sx }: UserAvatarProps) => {
  return (
    <Box sx={{ display: "flex", gap: "8px", alignItems: "center", ...sx }}>
      <Image
        hideSkeleton
        src={
          imgSrc ||
          ImageService.getLocalIconPath(
            Icons.Folders.GENERAL,
            Icons.General.Avatar
          )
        }
        sx={{ height: "40px", width: "40px" }}
      />
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography fontWeight={"100"} color="white">
          {subtitle}
        </Typography>
        <Typography color="white" fontWeight={"500"} fontSize={"18px"}>
          {username}
        </Typography>
      </Box>
    </Box>
  );
};

export default UserAvatar;
